import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@syneto/compass-react';
import usePartnerPreviewNotificationRecipients from '../../../../../../hooks/usePartnerPreviewNotificationRecipients';
import useRecipientSelection from '../../../../../../hooks/useRecipientSelection';
import {
	RECIPIENTS_STATUS,
	isConfirmEnabled,
	isSelectionRequired
} from '../../../../../../helpers/partnerPreviewRecipients';
import PartnerPreviewEnrollmentNotice from './PartnerPreviewEnrollmentNotice';
import PartnerPreviewRecipientList from './PartnerPreviewRecipientList';
import PartnerPreviewRecipientsStatus from './PartnerPreviewRecipientsStatus';

const PartnerPreviewConfirmationModal = ({ companyId, onHide, onConfirm }) => {
	const [notifyCustomer, setNotifyCustomer] = useState(true);
	const { status, recipients, error, isRetrying, retry } = usePartnerPreviewNotificationRecipients(companyId);
	const { selectedEmails, toggle, selectAll, clearAll } = useRecipientSelection(recipients);

	// Computed once: it drives both the validation message and whether Confirm is enabled.
	const isSelectionMissing = isSelectionRequired(selectedEmails.length);

	const handleNotifyCustomerChange = (event) => {
		setNotifyCustomer(event.target.checked);
	};

	const handleConfirm = () => {
		return onConfirm(notifyCustomer ? { recipients: selectedEmails } : null);
	};

	const renderRecipients = () => {
		return (
			<>
				<PartnerPreviewRecipientsStatus status={status} error={error} isRetrying={isRetrying} onRetry={retry} />
				{status === RECIPIENTS_STATUS.READY && (
					<PartnerPreviewRecipientList
						recipients={recipients}
						selectedEmails={selectedEmails}
						showSelectionRequired={isSelectionMissing}
						onToggleRecipient={toggle}
						onSelectRecipients={selectAll}
						onClearRecipients={clearAll}
					/>
				)}
			</>
		);
	};

	return (
		<Modal
			show={true}
			onHide={onHide}
			title="Enable Partner Preview Program"
			content={
				<PartnerPreviewEnrollmentNotice
					notifyCustomer={notifyCustomer}
					onNotifyCustomerChange={handleNotifyCustomerChange}
				>
					{renderRecipients()}
				</PartnerPreviewEnrollmentNotice>
			}
			actions={{
				primary: {
					label: 'Confirm',
					onClick: handleConfirm,
					disabled: !isConfirmEnabled({ notifyCustomer, status, isSelectionMissing })
				},
				secondary: {
					label: 'Cancel',
					onClick: onHide
				}
			}}
		/>
	);
};

export default PartnerPreviewConfirmationModal;

PartnerPreviewConfirmationModal.propTypes = {
	companyId: PropTypes.string.isRequired,
	onHide: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired
};
